// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/.deno/css-loader@6.11.0/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/.deno/css-loader@6.11.0/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".TableDataTxs-module__imgStatus___Nn95g{width:20px;height:20px;margin-right:5px}.TableDataTxs-module__type___FGi55{max-width:100px}", "",{"version":3,"sources":["webpack://./src/components/TableTxsInfinite/component/TableDataTxs.module.scss"],"names":[],"mappings":"AAAA,wCACE,UAAA,CACA,WAAA,CACA,gBAAA,CAGF,mCACE,eAAA","sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"imgStatus": "TableDataTxs-module__imgStatus___Nn95g",
	"type": "TableDataTxs-module__type___FGi55"
};
export default ___CSS_LOADER_EXPORT___;
